import { atomWithStorage } from "jotai/utils";

const parseStoredString = (value: string | null) => {
	if (value === null) return undefined;
	try {
		const parsed = JSON.parse(value);
		return typeof parsed === "string" ? parsed : undefined;
	} catch {
		return value;
	}
};

const authStorage = {
	getItem: (key: string, initialValue: string | undefined) => {
		if (typeof window === "undefined") return initialValue;
		const storedValue = parseStoredString(window.localStorage.getItem(key));
		return storedValue ?? initialValue;
	},
	setItem: (key: string, value: string | undefined) => {
		if (typeof window === "undefined") return;
		if (value === undefined) {
			window.localStorage.removeItem(key);
			return;
		}

		window.localStorage.setItem(key, JSON.stringify(value));
	},
	removeItem: (key: string) => {
		if (typeof window === "undefined") return;
		window.localStorage.removeItem(key);
	},
	subscribe: (key: string, callback: (value: string | undefined) => void) => {
		if (typeof window === "undefined") return () => {};
		const handler = (event: StorageEvent) => {
			if (event.key === key) {
				callback(parseStoredString(event.newValue));
			}
		};
		window.addEventListener("storage", handler);
		return () => window.removeEventListener("storage", handler);
	},
};

export const accessTokenAtom = atomWithStorage<string | undefined>("accessToken", undefined, authStorage);
export const refreshTokenAtom = atomWithStorage<string | undefined>("refreshToken", undefined);
